import { createStore } from 'zustand/vanilla';

export type ToastVariant = 'default' | 'success' | 'danger';

export interface ToastItem {
  readonly id: string;
  readonly title: string;
  readonly description?: string;
  readonly variant: ToastVariant;
}

interface ToastState {
  toasts: ToastItem[];
  push: (toast: Omit<ToastItem, 'id'>) => void;
  dismiss: (id: string) => void;
}

/**
 * Vanilla store so it can be driven imperatively from non-React code (the global
 * query/mutation error handler) AND subscribed to by the <Toaster /> UI.
 */
export const toastStore = createStore<ToastState>((set) => ({
  toasts: [],
  push: (toast) =>
    set((state) => ({ toasts: [...state.toasts, { ...toast, id: crypto.randomUUID() }] })),
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));

function withDescription(description?: string): { description?: string } {
  return description !== undefined ? { description } : {};
}

export const toast = {
  show: (title: string, description?: string) =>
    toastStore.getState().push({ title, variant: 'default', ...withDescription(description) }),
  success: (title: string, description?: string) =>
    toastStore.getState().push({ title, variant: 'success', ...withDescription(description) }),
  error: (title: string, description?: string) =>
    toastStore.getState().push({ title, variant: 'danger', ...withDescription(description) }),
};
